import Vue from "vue";
import Router from "vue-router";
import routes from "./routes.js";

Vue.use(Router);
let router = new Router(routes);

router.beforeEach(async (to, from, next) => {
  // Handle old UI authentication if query parameters exist
  if (urlHasAuthQuery(to)) {
    console.log("Old UI login detected");
    handleOldUIAuthentication(to);
    next({ path: to.path });
    return;
  }
  // Redirect root to /v
  if (to.path === "" || to.path === "/") {
    next({ path: "/v" });
    return;
  }

  // Handle login complete path
  if (to.path.includes("/login/complete")) {
    if (window.location.hash) {
      try {
        await router.app.$msal.handleAuthentication();
        const redirectUrl = router.app.$store.getters["auth/getRedirectUrl"];
        router.app.$store.dispatch("auth/setRedirectUrl", null);
        next(redirectUrl || "/v");
      } catch (error) {
        console.error("Error in login complete flow:", error);
        next("/v");
      }
      return;
    }

    // If no hash but already authenticated, redirect to home or stored URL
    if (router.app.$store.getters["auth/isAuthenticated"]) {
      const redirectUrl = router.app.$store.getters["auth/getRedirectUrl"];
      router.app.$store.dispatch("auth/setRedirectUrl", null);
      next(redirectUrl || "/v");
      return;
    }
    next();
    return;
  }

  // Check authentication for all other routes
  const isAuthenticated = router.app?.$store.getters["auth/isAuthenticated"];

  if (!isAuthenticated && !to.meta?.isForLoggedOutUsers) {
    // Save the intended destination before redirecting to login
    router.app.$store.dispatch("auth/setRedirectUrl", to.fullPath);
    // Only initiate login if we're not already on the login complete page
    if (!to.path.includes("/login/complete")) {
      router.app.$msal.initiateLogin().then(() => {
        next();
      });
    }
    return;
  }

  // SuperAdmin route guard
  if (to.meta?.isForSuperAdmin) {
    const isSuperAdmin = router.app?.$store?.getters["auth/isSuperAdmin"];
    if (!isSuperAdmin) {
      next({ path: "/v" });
      return;
    }
  }
  next();
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title;
  });
});

function urlHasAuthQuery(route) {
  return route.query.user && route.query.token;
}

function handleOldUIAuthentication(route) {
  console.log("handle old UI authentication");
  const userId = route.query.user,
    accessToken = route.query.token;

  router.app?.$store.dispatch("auth/resetState"); // Clear state in case already logged in as different user
  router.app?.$store.dispatch("auth/setAuthentication", {
    userId: userId,
    accessToken: accessToken,
  });
  router.app?.$store.dispatch("auth/setIsLoginFromOldUI", true);
  router.app?.$auth.getPermissions(accessToken);
}

export { router };
